import { Card } from "flowbite-react";
import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import Enderecos from "../../common/query/Enderecos";
import Emails from "../../common/query/Emails";
import Telefones from "../../common/query/Telefones";
import { countDadosCadastrais, formatDocument } from "../../../utils/utils";

const CadastralPFQuery = ({ data, dataFull }) => {
  const totalDadosCadastrais = Array.isArray(dataFull)
    ? dataFull.reduce((acc, item) => acc + countDadosCadastrais(item), 0)
    : countDadosCadastrais(dataFull);

  const podeRenderizarDadosCadastrais = totalDadosCadastrais < 3;

  return (
    <>
      {podeRenderizarDadosCadastrais && (
        <>
          {" "}
          <TitleStripe>👤 Dados Cadastrais</TitleStripe>
          <div className="border border-gray-200 rounded-xl p-6 bg-white">
            <div className="grid grid-cols-2 gap-6 text-base">
              <div>
                <p className="text-gray-500 font-medium">Nome completo</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.nome || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">CPF</p>
                <p className="text-gray-800">
                  {formatDocument(data?.dadosCadastrais?.cpf) || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Nome da mãe</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.nomeMae || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Sexo</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.sexo || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Data de nascimento</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.dataNascimento || "Indisponível"}
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      {data?.participacaoEmEmpresas && (
        <div>
          <TitleStripe>🏢 Participação em empresas</TitleStripe>
          {data?.participacaoEmEmpresas?.length > 0 ? (
            <ParticipacaoEmEmpresas empresas={data?.participacaoEmEmpresas} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.enderecos && (
        <div>
          <TitleStripe>📍 Endereços</TitleStripe>
          {data?.enderecos?.length > 0 ? (
            <Enderecos enderecos={data?.enderecos} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.emails && (
        <div>
          <TitleStripe>📧 E-mails</TitleStripe>
          {data?.emails?.length > 0 ? (
            <Emails emails={data?.emails} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.telefones && (
        <div>
          <TitleStripe>☎️ Telefones</TitleStripe>
          {data?.telefones?.length > 0 ? (
            <Telefones telefones={data?.telefones} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}
    </>
  );
};

export default CadastralPFQuery;
